import React from "react";
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import { Field, reduxForm } from "redux-form";
import TextField from 'material-ui/TextField';

const campoSettings = {
	fontStyle: 'normal',
	mixBlendMode: 'normal',
	fontFamily: 'Open Sans',
	fontWeight: 'normal',
}

const floatingLabelStyleSettings = {
	...campoSettings,
	color: '#0C2040',
	letterSpacing: '0.5px',
	lineHeight: '16px',
}

const floatingLabelFocusStyleSettings = {
	...campoSettings,
	color: '#FF6B0B',	
	letterSpacing: '0.5px',
	lineHeight: '16px',
}

const campo = ({ input, label, max, type, focus, meta: { touched, error } }) => {
	return (
		<MuiThemeProvider>
			<TextField
				{...input}
				maxLength={max}
				errorText={touched && error}
				floatingLabelStyle={floatingLabelStyleSettings}
				floatingLabelFocusStyle={floatingLabelFocusStyleSettings}
				type={type}
				onFocus={focus}
				underlineStyle={{ borderColor: '#AAC3EE' }}
				underlineFocusStyle={{ borderColor: '#FF6B0B' }}
				onBlur={(event) => { input.onBlur(event); }}
				onChange={(event) => { input.onChange(event); }}
				floatingLabelText={label}
				fullWidth={true}
				onKeyPress={(event) => {
					if (event.key === 'Enter') {
						handleKeyPress(input);
					}
				}}
			/>
		</MuiThemeProvider>
	);
};

export default class CampoField extends React.Component {

    componentWillMount = () => {
        console.log("");
    }

    render() {
        return <div>
            <Field name={this.props.name} type={this.props.type} label={this.props.label} max={this.props.max}  component={campo} />
        </div>;
    }
}

CampoField = reduxForm({ form: "datos-poliza" })(CampoField);


// WEBPACK FOOTER //
// ./src/gnp-registro/campo-field.frm.js